module.exports = __webpack_public_path__ + "img/carrusel_2.aa36a789.jpg";